export default __webpack_public_path__ + "static/media/complementary--chevron-left--g2.6443d98c.png";